var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { COOKIE_PARAM } from '../models';
import { LISTINGS_SOURCE_PARAM } from '../models/constants';
import { calculateSeed } from './CalculateSeed';
import { getConversionTrackingEndpoint, getConversionTrackingListingsEndpoint } from '../utils/endpointProviders';
var ConversionTrackingReporter = /** @class */ (function () {
    function ConversionTrackingReporter(httpRequesterService, debug) {
        this.httpRequesterService = httpRequesterService;
        this.debug = debug;
        this._debug = debug;
        this._conversionTrackingEndpoint = getConversionTrackingEndpoint();
        this._conversionTrackingListingsEndpoint = getConversionTrackingListingsEndpoint();
    }
    /**
     * Prints event details to the console for debugging of analytics events as they fire.
     * @param event - the details of the event that will be printed
     * @param type - the type of the event that was tracked
     */
    ConversionTrackingReporter.prototype.printEvent = function (event, type) {
        if (!this._debug)
            return;
        console.log("%c[YextAnalytics]%c- Tracked ".concat(type, " event: ").concat(event), 'background: white; color: blue;', '');
    };
    ConversionTrackingReporter.prototype.handleRequest = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var res, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpRequesterService.get(url.toString())];
                    case 1:
                        res = _a.sent();
                        if (!(res.status !== 200 && !(res.type === 'opaqueredirect' || res.type === 'opaque'))) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.text()];
                    case 2:
                        errorMessage = _a.sent();
                        throw new Error(errorMessage);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ConversionTrackingReporter.formatBaseEvent = function (event, params) {
        params.set(COOKIE_PARAM, event.cookieId);
        if (event.referrer)
            params.set('referrer', event.referrer);
        params.set('v', calculateSeed().toString());
        params.set('location', event.location);
    };
    /** {@inheritDoc ConversionTrackingService.trackConversion} */
    ConversionTrackingReporter.prototype.trackConversion = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var url, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(this._conversionTrackingEndpoint);
                        params = new URLSearchParams();
                        params.set('cid', event.cid);
                        if (event.cv)
                            params.set('cv', event.cv);
                        ConversionTrackingReporter.formatBaseEvent(event, params);
                        url.search = params.toString();
                        return [4 /*yield*/, this.handleRequest(url.toString())];
                    case 1:
                        _a.sent();
                        this.printEvent(event.cid, 'Conversion');
                        return [2 /*return*/];
                }
            });
        });
    };
    /** {@inheritDoc ConversionTrackingService.trackListings} */
    ConversionTrackingReporter.prototype.trackListings = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var url, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(this._conversionTrackingListingsEndpoint);
                        params = new URLSearchParams();
                        params.set(LISTINGS_SOURCE_PARAM, event.source);
                        ConversionTrackingReporter.formatBaseEvent(event, params);
                        url.search = params.toString();
                        return [4 /*yield*/, this.handleRequest(url.toString())];
                    case 1:
                        _a.sent();
                        this.printEvent(event.source, 'Listings Click');
                        return [2 /*return*/];
                }
            });
        });
    };
    /** {@inheritDoc ConversionTrackingService.setDebugEnabled} */
    ConversionTrackingReporter.prototype.setDebugEnabled = function (enabled) {
        this._debug = enabled;
    };
    return ConversionTrackingReporter;
}());
export { ConversionTrackingReporter };
//# sourceMappingURL=ConversionTrackingReporter.js.map